"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ApplyMarkdownInputAssist: () => ApplyMarkdownInputAssist
});
module.exports = __toCommonJS(src_exports);

// src/caret_operation.ts
var getCaretInfo = function(element) {
  const res = {
    text: "",
    start: 0,
    end: 0
  };
  if (!element.value) {
    return res;
  }
  try {
    res.start = element.selectionStart;
    res.end = element.selectionEnd;
    res.text = element.value.slice(res.start, res.end);
  } catch (e) {
  }
  return res;
};
var CaretOperation = {
  getPos: function(element) {
    const tmp = getCaretInfo(element);
    return { start: tmp.start, end: tmp.end };
  },
  setPos: function(element, toRange, caret = "keep") {
    if (caret === "start") {
      toRange.end = toRange.start;
    } else if (caret === "end") {
      toRange.start = toRange.end;
    }
    element.focus();
    try {
      element.setSelectionRange(toRange.start, toRange.end);
    } catch (e) {
    }
  },
  getText: function(element) {
    return getCaretInfo(element).text;
  }
};

// src/utils.ts
var getCurrentLine = function(e) {
  if (e.target === null)
    return;
  const target = e.target;
  const text = target.value;
  const pos = CaretOperation.getPos(target);
  if (!text) {
    return null;
  }
  if (pos.start !== pos.end) {
    return null;
  }
  const startPos = text.lastIndexOf("\n", pos.start - 1) + 1;
  let endPos = text.indexOf("\n", pos.start);
  if (endPos === -1) {
    endPos = text.length;
  }
  return {
    text: text.slice(startPos, endPos),
    start: startPos,
    end: endPos,
    caret: pos.start,
    endOfLine: !text.slice(pos.start, endPos).trim()
  };
};
var getPrevLine = function(e) {
  if (e.target === null)
    return;
  const target = e.target;
  const currentLine = getCurrentLine(e);
  if (currentLine === null || typeof currentLine === "undefined") {
    return null;
  }
  const text = target.value.slice(0, currentLine.start);
  const startPos = text.lastIndexOf("\n", currentLine.start - 2) + 1;
  const endPos = currentLine.start;
  return {
    text: text.slice(startPos, endPos),
    start: startPos,
    end: endPos
  };
};
var replaceText = function(target, str) {
  const pos = CaretOperation.getPos(target);
  const fromIdx = pos.start;
  const toIdx = pos.end;
  if (str === "")
    return;
  target.focus();
  target.selectionStart = fromIdx;
  target.selectionEnd = toIdx;
  if (!document.execCommand("insertText", false, str)) {
    const startText = target.value.slice(0, fromIdx);
    const endText = target.value.slice(toIdx);
    target.value = startText + str + endText;
  }
};

// src/handlers/enter.ts
var RegExpList = {
  listMarker: /^(\s*(?:-|\+|\*|\d+\.) )/,
  listMarkerWithPossibleCheckbox: /^(\s*(?:-|\+|\*|\d+\.) (?:\[(?:x| )\] )?)\s*\S/,
  emptyListItem: /^(\s*(?:-|\+|\*|\d+\.) (?:\[(?:x| )\] ))\s*$/
};
var handleEnterKey = function(e) {
  if (e.target === null)
    return;
  const target = e.target;
  let currentLine, match;
  if (e.metaKey || e.ctrlKey || e.shiftKey) {
    return;
  }
  if (!(currentLine = getCurrentLine(e))) {
    return;
  }
  if (currentLine.start === currentLine.caret) {
    return;
  }
  if (match = currentLine.text.match(RegExpList.listMarkerWithPossibleCheckbox)) {
    let listMarkMatch;
    if (currentLine.text.match(RegExpList.emptyListItem)) {
      CaretOperation.setPos(target, {
        start: currentLine.start,
        end: currentLine.end - 1
      });
      return;
    }
    e.preventDefault();
    let listMark = match[1].replace(/\[x\]/, "[ ]");
    if (listMarkMatch = listMark.match(/^(\s*)(\d+)\./)) {
      const indent = listMarkMatch[1];
      const num = parseInt(listMarkMatch[2]);
      if (num !== 1) {
        listMark = listMark.replace(/\s*\d+/, `${indent}${num + 1}`);
      }
    }
    replaceText(target, "\n" + listMark);
    const caretTo = currentLine.caret + listMark.length + 1;
    CaretOperation.setPos(target, { start: caretTo, end: caretTo });
  } else if (currentLine.text.match(RegExpList.listMarker)) {
    CaretOperation.setPos(target, {
      start: currentLine.start,
      end: currentLine.end
    });
  } else if (currentLine.text.match(/^.*\|\s*$/)) {
    if (currentLine.text.match(/^[|\s]+$/)) {
      CaretOperation.setPos(target, {
        start: currentLine.start,
        end: currentLine.end
      });
      return;
    }
    if (!currentLine.endOfLine) {
      return;
    }
    e.preventDefault();
    const row = [];
    const m = currentLine.text.match(/\|/g);
    if (m === null) {
      return;
    }
    for (match of Array.from(m)) {
      row.push("|");
    }
    const prevLine = getPrevLine(e);
    if (!prevLine || !currentLine.text.match(/---/) && !prevLine.text.match(/\|/g)) {
      replaceText(target, "\n" + row.join(" --- ") + "\n" + row.join("  "));
      CaretOperation.setPos(target, {
        start: currentLine.caret + 6 * row.length - 1,
        end: currentLine.caret + 6 * row.length - 1
      });
    } else {
      replaceText(target, "\n" + row.join("  "));
      CaretOperation.setPos(target, {
        start: currentLine.caret + 3,
        end: currentLine.caret + 3
      });
    }
  }
  document.dispatchEvent(new Event("input"));
};

// src/handlers/space.ts
var handleSpaceKey = function(e) {
  if (e.target === null)
    return;
  const currentLine = getCurrentLine(e);
  if (!currentLine)
    return;
  const target = e.target;
  const match = currentLine.text.match(
    /^(\s*)(-|\+|\*|\d+\.) (?:\[(x| )\] )(.*)/
  );
  if (match) {
    e.preventDefault();
    const checkMark = match[3] === " " ? "x" : " ";
    const replaceTo = `${match[1]}${match[2]} [${checkMark}] ${match[4]}`;
    CaretOperation.setPos(target, {
      start: currentLine.start,
      end: currentLine.end
    });
    replaceText(target, replaceTo);
    CaretOperation.setPos(target, {
      start: currentLine.caret,
      end: currentLine.caret
    });
    document.dispatchEvent(new Event("input"));
  }
};

// src/handlers/tab.ts
var handleTabKey = function(e) {
  if (e.target === null)
    return;
  const target = e.target;
  let newPos;
  e.preventDefault();
  const currentLine = getCurrentLine(e);
  const text = target.value;
  const pos = CaretOperation.getPos(target);
  if (currentLine) {
    CaretOperation.setPos(target, {
      start: currentLine.start,
      end: currentLine.end
    });
  }
  if (e.shiftKey) {
    if (currentLine && currentLine.text.charAt(0) === "|") {
      newPos = text.lastIndexOf("|", pos.start - 1);
      if (newPos > 1) {
        newPos -= 1;
      }
      CaretOperation.setPos(target, { start: newPos, end: newPos });
    } else {
      const currentText = CaretOperation.getText(target);
      const reindentedText = currentText.replace(/^ {1,4}/gm, "");
      const reindentedCount = currentText.length - reindentedText.length;
      replaceText(target, reindentedText);
      if (currentLine) {
        CaretOperation.setPos(target, {
          start: pos.start - reindentedCount,
          end: pos.start - reindentedCount
        });
      } else {
        CaretOperation.setPos(target, {
          start: pos.start,
          end: pos.start + reindentedText.length
        });
      }
    }
  } else {
    if (currentLine && currentLine.text.charAt(0) === "|") {
      newPos = text.indexOf("|", pos.start + 1);
      if (newPos < 0 || newPos === text.lastIndexOf("|", currentLine.end - 1)) {
        CaretOperation.setPos(target, {
          start: currentLine.end,
          end: currentLine.end
        });
      } else {
        CaretOperation.setPos(target, {
          start: newPos + 2,
          end: newPos + 2
        });
      }
    } else {
      const indentedText = "    " + CaretOperation.getText(target).split("\n").join("\n    ");
      replaceText(target, indentedText);
      if (currentLine) {
        CaretOperation.setPos(target, {
          start: pos.start + 4,
          end: pos.start + 4
        });
      } else {
        CaretOperation.setPos(target, {
          start: pos.start,
          end: pos.start + indentedText.length
        });
      }
    }
  }
  document.dispatchEvent(new Event("input"));
};

// src/handler.ts
var esareaDetected = false;
var isEsareaInstalled = () => {
  if (esareaDetected)
    return true;
  const meta = document.querySelector('meta[name="esarea"]');
  if (meta) {
    esareaDetected = true;
  }
  return esareaDetected;
};
var KeyDownHandler = function(e) {
  if (isEsareaInstalled())
    return;
  const key = e.key.toLowerCase();
  if (key === "tab") {
    handleTabKey(e);
  } else if (key === "enter") {
    handleEnterKey(e);
  } else if (
    // FIXME: Strangely `e.key === ' '`  does not work.
    e.code === "Space" && e.shiftKey && e.altKey
  ) {
    handleSpaceKey(e);
  }
};

// src/index.ts
var ApplyMarkdownInputAssist = function(editor) {
  editor.addEventListener("keydown", KeyDownHandler);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ApplyMarkdownInputAssist
});
